export default __webpack_public_path__ + "static/media/pending_verification_bg.079bf08e.png";